const domain = `https://${window.location.hostname}`;

const visibilityData = {
  1: {
    header: `Pozycjonowanie pomaga zwiększyć sprzedaż`,
    headerDesc: `Dzięki lepszej widoczności przyciągniesz więcej klientów i zwiększysz swoją sprzedaż.`,
    title: 'Wzrost <span class="text--color-accent">sprzedaży</span>',
    text: `Wielu właścicieli e-commerce zastanawia się, jak zwiększyć sprzedaż w sklepie internetowym. W Last Agency budujemy strategie rozwoju, które przekładają się na wzrost zysków ze sprzedaży.`,
    link: "#1",
    listItems: [
      `<li class="list-square__item">
            <span>
                <b>Większe przychody,</b> które pozwalają inwestować w ciągły rozwój sklepu internetowego oraz poszerzać asortyment.
            </span>
        </li>`,
      `<li class="list-square__item">
            <span>
              <b>Wzmocnienie pozycji na rynku,</b> co sprzyja budowaniu przewagi konkurencyjnej i zwiększa zaufanie klientów.
            </span>
        </li>`,
      `<li class="list-square__item">
            <span>
                <b>Możliwość rozszerzenia kanałów sprzedaży,</b> dzięki czemu dotrzesz do nowych segmentów klientów i zwiększyć zasięg marki.
            </span>
        </li>`,
    ],
    imgurl: `${domain}/wp-content/themes/omnite/img/photos/chall_sprzedaz.webp`,
  },
  2: {
    header: `SEO to szansa na dotarcie do nowych klientów`,
    headerDesc: `Pozycjonowanie dla e-commerce pozwala zwiększyć ruch na stronie. Inwestuj w rozwiązania, które działają.`,
    title: 'Wzrost <span class="text--color-accent">ruchu</span>',
    text: `Dobrze przeprowadzone pozycjonowanie dla e-commerce dają szanse na zwiększenie ruchu na stronie. Dzięki odpowiednim działaniom w końcu trafią do Ciebie klienci, którzy naprawdę szukają Twoich produktów.`,
    link: "#2",
    listItems: [
      `<li class="list-square__item">
            <span>
                <b>Wyższy współczynnik konwersji.</b> Więcej odwiedzających to szansa na większą liczbę transakcji, co bezpośrednio przekłada się na wzrost przychodów
            </span>
        </li>`,
      `<li class="list-square__item">
            <span>
              <b>Większą liczbę potencjalnych klientów.</b> Wraz ze wzrostem liczby odwiedzających rośnie grono potencjalnych klientów, którzy mogą zainteresować się Twoją ofertą i zdecydować się na zakup.
            </span>
        </li>`,
      `<li class="list-square__item">
            <span>
                <b>Wzrost rozpoznawalności marki.</b> Każdy nowy klient, do którego dotrzesz, to wartość dodana dla budowania rozpoznawalności Twojego brandu.
            </span>
        </li>`,
    ],
    imgurl: `${domain}/wp-content/themes/omnite/img/photos/chall_ruch.webp`,
  },
  3: {
    header: `Rozpoznawalność marki, która rośnie wraz z pozycjami`,
    headerDesc: `Dzięki skutecznej strategii SEO Twoja marka nie tylko zyskuje lepsze pozycje, ale staje się również bardziej rozpoznawalna i doceniana wśród odbiorców.`,
    title: 'Wzrost <span class="text--color-accent">rozpoznawalności</span>',
    text: `Zwiększaj rozpoznawalność swojej marki, budując jej obecność na szczycie wyników wyszukiwania. Im wyższa pozycja Twojej strony, tym większa widoczność i zaufanie klientów.`,
    link: "#3",
    listItems: [
      `<li class="list-square__item">
            <span>
                <b>Wyższą wartość koszyka.</b> Klienci, którzy znają markę, są skłonni wydawać więcej przy każdym zakupie.
            </span>
        </li>`,
      `<li class="list-square__item">
            <span><b>Szansę na ekspansję.</b> Rozpoznawalność w branży pozwala szybciej zdobyć nowych odbiorców i rozpocząć sprzedaż na rynkach zagranicznych.</span>
        </li>`,
      `<li class="list-square__item">
            <span>
                <b>Lojalnych klientów.</b> Dobra rozpoznawalność marki motywuje klientów do regularnych zakupów i budowania trwałych relacji z firmą.
            </span>
        </li>`,
    ],
    imgurl: `${domain}/wp-content/themes/omnite/img/photos/chall_rozpoznawalnosc.webp`,
  },
  4: {
    header: `Szybsze finalizowanie transakcji przez klientów`,
    headerDesc: `Skrócenie cyklu sprzedażowego to wiele korzyści dla e-commerce, które przekładają się zarówno na zadowolenie klientów, jak i wzrost zysków z przedsiębiorstwa.`,
    title: 'Szybszy <span class="text--color-accent">cykl sprzedaży</span>',
    text: `Szybszy cykl sprzedaży w e-commerce oznacza skrócenie czasu, jaki upływa od momentu, gdy klient po raz pierwszy zetknie się z marką lub produktem, do chwili dokonania zakupu. Dzięki temu e-commerce może szybciej przekształcać odwiedzających użytkowników w finalizujących transakcje klientów.`,
    link: "#4",
    listItems: [
      `<li class="list-square__item">
            <span>
                <b>Obniżenie kosztów sprzedaży.</b> Krótki cykl sprzedaży oznacza niższe koszty. Dobrze zaplanowany proces wymaga zaangażowania mniejszych zasobów do tego, by sprzedać dany produkt.
            </span>
        </li>`,
      `<li class="list-square__item">
            <span><b>Poprawę płynności finansowej.</b> Szybsze zamykanie sprzedaży zwiększa przepływ środków finansowych, co pozwala firmie lepiej zarządzać kapitałem.</span>
        </li>`,
      `<li class="list-square__item">
            <span>
                <b>Wzrost konwersji.</b> Klienci, dzięki skróceniu cyklu sprzedaży, szybciej podejmują decyzję zakupową. To przekłada się na wyższy współczynnik konwersji i wzrost finalizowanych transakcji.
            </span>
        </li>`,
    ],
    imgurl: `${domain}/wp-content/themes/omnite/img/photos/chall_cykl.webp`,
  },
};
